export type AddEquipmentStep = 'options' | 'qr' | 'search' | 'form';

export interface EquipmentFormState {
  readonly title: string;
  readonly make: string;
  readonly model: string;
  readonly serial: string;
  readonly location: string;
}

export const EMPTY_EQUIPMENT_FORM: EquipmentFormState = {
  title: '',
  make: '',
  model: '',
  serial: '',
  location: '',
};
